import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    entities: {},
    ids: [],
};
const documentsSlice = createSlice({
    name: 'documents',
    initialState,
    reducers: {
        setDocuments(state, action) {
            state.entities = {};
            state.ids = [];
            for (const doc of action.payload) {
                state.entities[doc.id] = doc;
                state.ids.push(doc.id);
            }
        },
        upsertDocument(state, action) {
            const doc = action.payload;
            state.entities[doc.id] = doc;
            if (!state.ids.includes(doc.id)) {
                state.ids.push(doc.id);
            }
        },
        removeDocument(state, action) {
            const id = action.payload;
            delete state.entities[id];
            state.ids = state.ids.filter(did => did !== id);
        },
        updateDocumentMetadata(state, action) {
            const { id, changes } = action.payload;
            const existing = state.entities[id];
            if (existing) {
                Object.assign(existing, changes);
            }
        },
    },
});
export const { setDocuments, upsertDocument, removeDocument, updateDocumentMetadata } = documentsSlice.actions;
export default documentsSlice.reducer;
//# sourceMappingURL=documentsSlice.js.map